import React, { useEffect } from 'react'
import { unpack } from 'rrweb'
import rrwebPlayer from 'rrweb-player'
import Container from '../../Context'
import ModalClose from '../Icons/ModalClose.svg'
import styles from './index.module.less'
import 'rrweb-player/dist/style.css'

const ReplayModal: React.FC<{ onCancel?: () => void }> = ({ onCancel }) => {
  const { events } = Container.useContainer()

  useEffect(() => {
    const handleReplay = async () => {
      setTimeout(() => {
        new rrwebPlayer({
          target: document.querySelector('#rrplayer'),
          props: {
            events,
            unpackFn: unpack,
            showController: true,
          },
        })
      })
    }
    handleReplay()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className={styles.mask}>
        <span className={styles.closeIcon} onClick={onCancel}>
          <img src={ModalClose} />
        </span>

        <div className={styles.content}>
          <div id="rrplayer"></div>
        </div>
      </div>
    </>
  )
}

export default ReplayModal
